import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import krukmgithub from '../assets/krukmgithub.png';
import exlogo from '../assets/exlogo.png';
import Card from '../components/Card';

class Carousel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [
                {
                    id: 0,
                    title: 'krukm github',
                    imgSrc: krukmgithub,
                    link: 'https://github.com/krukm',
                    selected: true
                },
                {
                    id: 1,
                    title: 'Expedia iOS app',
                    imgSrc: exlogo,
                    link: 'https://apps.apple.com/us/app/expedia-hotels-flights-car/id427916203',
                    selected: false
                }
            ]
        }
    }

    handleCardClick = (id, card) => {
        let items = [...this.state.items];

        items[id].selected = items[id].selected ? false : true;
        items.forEach(item => {
            if (item.id !== id) {
                item.selected = false
            }
        });

        this.setState({
            items
        });
    }

    makeItems = (items) => {
        return items.map(item => {
            return <Card item={item} click={(e => this.handleCardClick(item.id, e))} key={item.id} />
        })
    }

    render() {
        return (
            <Container fluid={true}>
                <Row className="justify-content-around">
                    {this.makeItems(this.state.items)}
                </Row>
            </Container>
        );
    }
}

export default Carousel;